var _g, _path, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalkPtBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34,
    viewBox: "0 0 52 34",
    width: 52,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h52v34h-52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-27.183 1450.1 1.446-.695a1.308 1.308 0 0 1 .459-.08h8.612a1.275 1.275 0 0 1 .453.08l1.446.695",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    transform: "translate(45.48 -1448.329)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.623 1v3.186",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-27.292 1471.661a1.081 1.081 0 0 1 1.082 1.082 1.081 1.081 0 0 1 -1.082 1.082 1.081 1.081 0 0 1 -1.082-1.081 1.082 1.082 0 0 1 1.081-1.083z",
    fill: "#3a3a3a",
    transform: "translate(45.48 -1448.329)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-30.316 1458.274c0-.373.551-.648 1.208-.679 5.792-.268 10.478-.229 16.268 0 .659.027 1.207.307 1.207.679",
    transform: "translate(45.48 -1448.329)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-15.742 1468.311c-5.5.374-14.574.089-14.574-.86",
    transform: "translate(45.48 -1448.329)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-21.761 1477.6q-3.162-.036-6.315-.368a2.6 2.6 0 0 1 -2.24-2.163v-18.627a3.9 3.9 0 0 1 3.844-3.938v.006h10.995a3.9 3.9 0 0 1 3.843 3.938v9.3",
    transform: "translate(45.48 -1448.329)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.978 32.024h7.527"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-36.031 1463.279a2.31 2.31 0 0 1 -2.305-2.315 2.311 2.311 0 0 1 2.316-2.305 2.311 2.311 0 0 1 2.305 2.316 2.308 2.308 0 0 1 -2.312 2.305z",
    transform: "translate(45.48 -1448.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-42.48 1470.812a4.759 4.759 0 0 1 4.76-4.759",
    transform: "translate(45.48 -1448.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-40.1 1473.191c2.508 0 4.538 3.2 4.538 7.156",
    transform: "translate(45.48 -1448.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-32.961 1470.812a4.759 4.759 0 0 1 -4.759-4.759",
    transform: "translate(45.48 -1448.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.76 17.722-4.76 14.278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-15.1 1471.451a4.437 4.437 0 0 1 4.437 4.438 4.437 4.437 0 0 1 -4.438 4.437 4.437 4.437 0 0 1 -4.437-4.438 4.436 4.436 0 0 1 4.437-4.437zm14.521 0a4.437 4.437 0 0 1 4.437 4.437 4.438 4.438 0 0 1 -4.437 4.438 4.438 4.438 0 0 1 -4.438-4.438 4.437 4.437 0 0 1 4.438-4.437zm-14.521 4.44 3.992-5.112 7.348-.744m1.216-2.07-2.068.148 4.03 7.773m-12.51-7.2h2.568",
    transform: "translate(45.48 -1448.328)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkPtBike);
export default __webpack_public_path__ + "static/media/walk-pt-bike.b62f6d528c3c7c3d4fc7c5f1a292723d.svg";
export { ForwardRef as ReactComponent };